import {Provider} from "@oilstone/container";
import Registry from "@/services/resources/registry";
import clients from "@/shared/resources/clients";
import citations from "@/shared/resources/citations";
import citationSpecialisations from "@/shared/resources/citation-specialisations";
import departments from "@/shared/resources/departments";
import fileAssets from "@/shared/resources/file-assets";
import modules from "@/shared/modules/resource";
import pageModules from "@/shared/resources/page-modules";
import pages from "@/shared/resources/pages";
import newsModules from "@/shared/resources/news-modules";
import newsAndViews from "@/shared/resources/news-and-views";
import news from "@/shared/resources/news";
import podcasts from "@/shared/resources/podcasts";
import podcastModules from "@/shared/resources/podcast-modules";
import blogPosts from "@/shared/resources/blog-posts";
import blogPostModules from "@/shared/resources/blog-post-modules";
import people from "@/shared/resources/people";
import personModules from "@/shared/resources/person-modules";
import personCitations from "@/shared/resources/person-citations";
import personSpecialisations from "@/shared/resources/person-specialisations";
import personDepartments from "@/shared/resources/person-departments";
import personNews from "@/shared/resources/person-news";
import personBlogPosts from "@/shared/resources/person-blog-posts";
import personPodcasts from "@/shared/resources/person-podcasts";
import specialisations from "@/shared/resources/specialisations";
import locations from "@/shared/resources/locations";
import locationModules from "@/shared/resources/location-modules";
import research from "@/shared/resources/research";
import testimonials from "@/shared/resources/testimonials";
import testimonialModules from "@/shared/resources/testimonial-modules";
import testimonialCategories from "@/shared/resources/testimonial-categories";
import testimonialTestimonialCategories from "@/shared/resources/testimonial-testimonial-categories";
import services from "@/shared/resources/services";
import serviceModules from "@/shared/resources/service-modules";
import serviceCategories from "@/shared/resources/service-categories";
import serviceServiceCategories from "@/shared/resources/service-service-categories";
import keyValues from "@/shared/resources/key-values";
import users from "@/shared/resources/users";

export default new Provider().register(container => {
    container.singleton('resourceRegistry', () => {
        const registry = new Registry();

        const resources = {
            clients,
            citations,
            citationSpecialisations,
            departments,
            fileAssets,
            modules,
            pageModules,
            pages,
            newsModules,
            news,
            podcasts,
            podcastModules,
            blogPosts,
            blogPostModules,
            newsAndViews,
            people,
            personModules,
            personCitations,
            personSpecialisations,
            personDepartments,
            personNews,
            personBlogPosts,
            personPodcasts,
            specialisations,
            locations,
            locationModules,
            research,
            testimonials,
            testimonialModules,
            testimonialCategories,
            testimonialTestimonialCategories,
            services,
            serviceModules,
            serviceCategories,
            serviceServiceCategories,
            keyValues,
            users,
        };

        Object.values(resources).forEach(resource => {
            registry.add(resource());
        });

        return registry;
    });
});
